export default __webpack_public_path__ + "static/media/arrow-right.df740a41.svg";